<template>
    <div>
        <b-modal id="create-location" size="lg" title="Adres Ekle" no-close-on-esc no-close-on-backdrop>
            <firm-create-or-update-location v-model="location" :countries="countries" :location-types="locationTypes"></firm-create-or-update-location>
            <template #modal-footer>
                <button class="btn btn-primary" v-on:click="createLocation">Kaydet</button>
            </template>
        </b-modal>

        <v-table    ref="table"
                    :add-callback="createNew"
                    :buttons="buttons"
                    name="firm-location"
                    :fields="fields"
                    with-items
                    :settings="false"
                    :items="value"></v-table>
    </div>
</template>

<script>
import FirmCreateOrUpdateLocation from '@/views/firm-operations/firm/components/FirmCreateOrUpdateLocation'
import SystemDataApi from '@/api/system-data'
import randomatic from 'randomatic'


export default {
    components:{
        FirmCreateOrUpdateLocation
    },
    props:{
        value:Array
    },
    mounted(){
        this.getCountries()
        this.getLocationTypes()
    },
    data(){
        return {
            buttons:[
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:(item,key,index)=>{ this.$delete(this.value,index) } },
            ],
            fields:[
                {name:"Lokasyon Tipi",key:"LocationType.Name"},
                {name:"Lokasyon Adı",key:"LocationName"},
                {name:"İl",key:"Province.Name"},
                {name:"İlçe",key:"District.Name"},
                {name:"Mahalle",key:"Neighborhood.Name"},
                {name:"Posta Kodu",key:"PostalCode"},
                {name:"Bina Numarası",key:"BuildingNumber"},
                {name:"Kat",key:"Floor"},
                {name:"Kapı Numarası",key:"DoorNumber"},
            ],
            countries:[],
            locationTypes:[],
            location:{
                FirmLocationDummyId:null,
                LocationName:null,
                LocationType:null,
                LocationTypeId:null,
                Country:null,
                CountryId:null,
                Province:null,
                ProvinceId:null,
                District:null,
                DistrictId:null,
                Neighborhood:null,
                NeighborhoodId:null,
                Street:null,
                StreetId:null,
                BuildingNumber:null,
                DoorNumber:null,
                Xcoordinate:null,
                Ycoordinate:null,
                Address:null,
                PostalCode:null,
                Floor:null,
                IsInvoiceAddress:false,
                InvoiceTitle:null,
                PostalAddress:null
            }
        }
    },
    methods:{
        clearForm(){
            this.location.FirmLocationDummyId=null
            this.location.LocationName=null
            this.location.LocationType=null
            this.location.LocationTypeId=null
            this.location.Country = null
            this.location.CountryId = null
            this.location.Province=null
            this.location.ProvinceId=null
            this.location.District=null
            this.location.DistrictId=null
            this.location.Neighborhood=null
            this.location.NeighborhoodId=null
            this.location.Street=null
            this.location.StreetId=null
            this.location.BuildingNumber=null
            this.location.DoorNumber=null
            this.location.Xcoordinate=null
            this.location.Ycoordinate=null
            this.location.Address=null
            this.location.PostalCode=null
            this.location.Floor=null
            this.location.IsInvoiceAddress=false
            this.location.InvoiceTitle=null
            this.location.PostalAddress=null
        },
        createNew(){
            this.clearForm()
            this.location.FirmLocationDummyId = randomatic("0",8)
            this.$showModal("create-location")
        },
        createLocation(){
            this.location.LocationName = this.location.LocationName?.toLocaleUpperCase()
            this.value.push(structuredClone(this.location))
            this.$hideModal("create-location")
        },
        getLocationTypes(){
            SystemDataApi.LocationType().then(response => {
                this.locationTypes = response.data.Data
            })
        },
        getCountries(){
            SystemDataApi.Country().then(response=>{
                this.countries = response.data.Data
            })
        }
    }
}
</script>

<style>

</style>